<template>
  <div>
    <div class="swiper">
      <mt-swipe class="spacing" :auto="4000">
        <mt-swipe-item v-for="(img, index) in swipeList" :key="index">
          <div>
            <img :src="img.slideshowPath" />
          </div>
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="iconList">
      <ul>
        <li @click="repair">
          <img src="../../assets/img/enterprise/repair.png" />
          <p>设备报修</p>
        </li>
        <li @click="cost">
          <img src="../../assets/img/enterprise/cost.png" />
          <p>费用查看</p>
        </li>
        <li @click="demand">
          <img src="../../assets/img/enterprise/demand.png" />
          <p>需求大厅</p>
        </li>
        <li @click="setting">
          <img src="../../assets/img/enterprise/setting.png" />
          <p>我的</p>
        </li>
      </ul>
    </div>
    <Announcement></Announcement>
  </div>
</template>
<script>
import Announcement from '@/components/Announcement/index'
import { getCookie } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const bannerOne = require('@/assets/img/enterprise/banner.png')
const bannerTwo = require('@/assets/img/enterprise/banner.png')
const bannerThree = require('@/assets/img/enterprise/banner.png')

export default {
  name: 'Home',
  components: { Announcement },
  data() {
    return {
      swipeList: [
        {
          id: 1,
          slideshowPath: bannerOne
        },
        {
          id: 2,
          slideshowPath: bannerTwo
        },
        {
          id: 3,
          slideshowPath: bannerThree
        }
      ]
    }
  },
  mounted() {
    const token = getCookie(ACCESS_TOKEN)
    if (!token) {
      this.$router.replace({
        name: 'login'
      })
    }
    // history.pushState(null, null, document.URL)
    // window.addEventListener('popstate', function () {
    //   history.pushState(null, null, document.URL)
    // })
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.resolveBack, false) // false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.resolveBack, false)
  },
  methods: {
    resolveBack() {
      WeixinJSBridge.call('closeWindow')
    },
    repair() {
      this.$router.push({
        name: 'repairList'
      })
    },
    cost() {
      this.$router.push({
        name: 'cost-me'
      })
    },
    demand() {
      this.$router.push({
        name: 'demand'
      })
    },
    setting() {
      this.$router.push({
        path: '/settings/home'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.iconList {
  ul {
    padding: 0 2px;
    background: #fff;
    margin-bottom: 0;

    li {
      width: 25%;
      float: left;
      padding: 18px 0px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      p {
        margin-bottom: 0;
        font-size: 13px;
        color: #333;
        font-family: 'Source Han Sans CN';
      }
    }
  }
}

.swiper {
  height: 161px;

  img {
    width: 375px;
    height: 161px;
  }
}
</style>
